import type { CampaignDetail, CampaignDraftState } from './api';

/** Limite do nome da campanha (`campaigns.name` é varchar(160)). */
const MAX_NOME = 160;
const PREFIXO = 'Cópia de ';

/**
 * Nome da cópia: "Cópia de <nome>". Duplicar uma cópia não empilha o prefixo
 * ("Cópia de Cópia de…") — o nome continua legível na lista.
 */
export function nomeDaCopia(nome: string): string {
  const base = nome.trim();
  return (base.startsWith(PREFIXO) ? base : `${PREFIXO}${base}`).slice(0, MAX_NOME);
}

/**
 * Estado do wizard pra DUPLICAR uma campanha. Leva só a CONFIGURAÇÃO (decisão
 * do dono, 14/out/2026): canal, template, variáveis, mídia do cabeçalho,
 * intervalo entre mensagens e roteamento das respostas. Os destinatários são
 * escolhidos de novo — a campanha não guarda o filtro usado, só a lista final.
 *
 * O envio nasce em "manual" (não dispara sozinho) e o agendamento da original
 * não vem junto: a data dela já passou ou é de outra ação. Abre no passo 1 pra
 * pessoa conferir nome e canal antes de seguir.
 */
export function estadoDaCopia(c: CampaignDetail): CampaignDraftState {
  const paraChatbot = c.response_destination === 'chatbot';
  return {
    step: 1,
    name: nomeDaCopia(c.name),
    whatsappNumberId: c.whatsapp_number_id,
    templateId: c.template_id,
    variables: { ...c.variables_map },
    headerMediaId: c.header_media_id,
    headerMediaName: c.header_media_name,
    messageDelaySeconds: c.message_delay_seconds,
    responseWindowMinutes: c.response_window_minutes,
    responseDestination: paraChatbot ? 'chatbot' : 'channel_default',
    responseChatbotId: paraChatbot ? c.response_chatbot_id : null,
    sendMode: 'manual',
  };
}
